/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/water-trash': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 22v1.73a.44.44 0 01-.43.43H9.18a.44.44 0 01-.43-.43V22a.43.43 0 01.43-.43h10.37A.43.43 0 0120 22zm2.46-12.29l-7.93-7.94L16.05.24a.45.45 0 01.61 0L24 7.57a.43.43 0 010 .61zM8.32 5.12a11.1 11.1 0 012.37.26 2.19 2.19 0 002-.57L14.52 3l6.72 6.72-1.82 1.82a2.17 2.17 0 00-.57 2 10.56 10.56 0 01.26 2.37v4.75H9.62v-4.75a1.3 1.3 0 00-1.3-1.29H3.57v-9.5zm-6 10.36H.55a.43.43 0 01-.43-.43V4.69a.43.43 0 01.43-.43h1.73a.43.43 0 01.43.43v10.36a.43.43 0 01-.43.43z" data-name="044---Pipe"/>'
  }
})
